import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import LinkedIn from '@mui/icons-material/LinkedIn';
import Twitter from '@mui/icons-material/Twitter';
import Tooltip from '@mui/material/Tooltip';
import recruiter_header_logo from "../../components/basicInfoForm/images/logo_recruiter_header.png";
import "./Footer.css";
const Footer = () => {
  const today = new Date();

  const goToTerms = (e) => {
    window.open("/terms-of-use", "_self");
  };
  const goToPrivacyPolicy = () => {
    window.open("/privacy-policy", "_self");
  };
  return (
    <>
      <div className="footer_recruiter_signup">
        <div className="footer_main_container_signup">
          <div className="container_rec_footer">
            <div className="footer_left_logo">
              <img src={recruiter_header_logo} alt="ClearedTalent Logo" />
            </div>
            
            <div className="footer-center">
              
              <div className="footer-links">
                <span className="copyright-text">
                  ClearedTalent © {today.getFullYear()}. All Rights Reserved.
                </span>
                <span className="footerTerms" onClick={goToTerms}>
                  Terms of Use
                </span>
                <span className="footerTerms" onClick={goToPrivacyPolicy}>
                  Privacy Policy
                </span>
              </div>
            </div>

            <div className="footer-right">
              <div className="social_links">
                <a
                  href="https://www.linkedin.com/company/clearedtalent/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Tooltip title="LinkedIn">
                    <LinkedIn className="iconColor" />
                  </Tooltip>
                </a>
                <a
                  href="https://www.facebook.com/Cleared-Talent"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Tooltip title="Facebook">
                    <Facebook className="iconColor" />
                  </Tooltip>
                </a>
                <a
                  href="https://twitter.com/Cleared_Talent"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Tooltip title="Twitter">
                    <Twitter className="iconColor" />
                  </Tooltip>
                </a>
                <a
                  href="https://www.instagram.com/clearedtalent/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Tooltip title="Instagram">
                    <Instagram className="iconColor" />
                  </Tooltip>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
